<script setup lang="ts">
import { RadioGroupItem, RadioGroupRoot } from 'radix-vue'

defineProps<{
  items: Array<{ key: string; value: string; text: string }>
}>()

const modelValue = defineModel<string>()
</script>
<template>
  <radio-group-root
    v-model="modelValue"
    class="switcher"
    default-value="default"
    orientation="horizontal"
  >
    <radio-group-item
      v-for="item in items"
      :key="item.key"
      class="switcher-item"
      :value="item.value"
    >
      {{ item.text }}
    </radio-group-item>
  </radio-group-root>
</template>

<style lang="scss">
.switcher {
  border-radius: 8px;
  background: #2c2d3e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 4px;

  &-item {
    flex: 1;
    border: none;
    outline: none;
    border-radius: 4px;
    background: #1f212e;

    display: flex;
    padding: 6px 12px;
    justify-content: center;
    align-items: center;
    background-color: inherit;

    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;

    &:hover {
      background: #3a3b4c;
    }

    &[data-state='checked'] {
      background: #1f212e;
      color: #fff;
    }
  }
}
</style>
